module.exports = __webpack_public_path__ + "media/image4.9f3caa56.mp4";